export default __webpack_public_path__ + "static/signage4-f610b43c29f0152659f85f9bf6b0c766.webp";